export default __webpack_public_path__ + "static/fantasy-climax-400-f8e7e89becd6ad8e59f389dd17137fa8.webp";